import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import { updateUser, deleteUser, fetchUser, clearBarbersByShop } from '../../actions';
import { getShops } from '../../../shops/reducers';
import { getUser } from '../../selectors';
import withNotifications from '../../../../common/withNotifications';
import { fetchShops } from '../../../shops/actions';
import confirmModal from '../../../../common/confirmModal';

const mapStateToProps = (state, props) => ({
  user: getUser(state, props.params.id),
  shops: getShops(state),
});

const mapDispatchToProps = {
  updateUser,
  deleteUser,
  fetchUser,
  fetchShops,
  clearBarbersByShop,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withRouter,
  lifecycle({
    componentWillMount() {
      if (this.props.params.id) {
        this.props.fetchUser(this.props.params.id);
      }
    },
  }),
  withHandlers({
    saveAndRedirect: props => data => props.updateUser(props.user.id, data)
      .then((user) => {
        const message = user.isAccountOwner
          ? t('admin:users.edit.update_success_account_owner')
          : t('admin:users.edit.update_success');
        props.addNotification({
          title: t('admin:users.edit.success_title'),
          level: 'success',
          message,
        });

        props.router.push('/admin/users');
        props.clearBarbersByShop();
        props.fetchShops();
      }),
    onLogoutAllClick: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:users.edit.logout_sessions_title'),
        message: t('admin:users.edit.logout_sessions_confirm'),
      });

      if (!confirmed) {
        return false;
      }

      return props.updateUser(props.user.id, { invalidateToken: true }).then(() =>
        props.addNotification({
          title: t('admin:users.edit.success_title'),
          level: 'success',
          message: t('admin:users.edit.logout_sessions_success'),
        })
      );
    },
    onDeleteClick: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:users.edit.delete_user_title'),
        message: t('admin:users.edit.delete_user_confirm'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteUser(props.user.id).then(() => {
        props.addNotification({
          title: t('admin:users.edit.success_title'),
          level: 'success',
          message: t('admin:users.edit.delete_user_success'),
        });

        return props.router.push('/admin/users');
      }
      );
    },
  })
);
